import { flow, observable, makeObservable } from 'mobx';
import BaseStore from './BaseStore';
import TeamMemberReviewAPI from '../api/team_member_review';

class TeamReviewStore extends BaseStore {
  isSent = false;
  hasError = false;

  create = flow(function* (payload, setErrors, setSubmitting) {
    try {
      this.hasError = false;
      yield TeamMemberReviewAPI.create(payload);
      this.isSent = true;
    } catch (e) {
      if (e.response?.data?.errorMessages) {
        setErrors(e.response.data.errorMessages);
      } else {
        // eslint-disable-next-line no-console
        console.error(e);
        this.hasError = true;
      }
      setSubmitting(false);
    }
  });

  constructor() {
    super();

    makeObservable(this, {
      isSent: observable,
      hasError: observable,
    });
  }
}

export default new TeamReviewStore();
